// import api from "..";
// import { playListPassword, playListUsername } from "../../../state";
// import { convertItemsToTilesChannelCategory, chunkArray } from "../formatters/ItemFormatter";
// import { dnsResolver } from "./dnsResolver";

// const cache = new Map<string, Promise<any>>();
// const leftoverTiles = new Map<string, any[]>();

// // Enhanced API call wrapper for categories
// const safeApiGetCategories = async (url, headers = {}) => {
//   const MAX_RETRIES = 2;
//   const RETRY_DELAY = 1000;

//   for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
//     try {
//       console.log(`📡 Categories API attempt ${attempt}/${MAX_RETRIES}: ${url}`);

//       const response = await api._get(url, { headers });

//       // Validate response is not HTML
//       if (typeof response === "string" && response.trim().startsWith("<")) {
//         throw new Error(`Received HTML instead of JSON for categories`);
//       }

//       console.log(`✅ Categories API call successful`);
//       return response;
//     } catch (error) {
//       console.warn(`⚠️ Categories API attempt ${attempt} failed:`, error.message);

//       if (
//         error.message.includes("Unexpected token <") ||
//         error.message.includes("JSON") ||
//         error.message.includes("HTML instead of JSON")
//       ) {
//         console.error(`❌ JSON parsing error for categories - server returned HTML`);
//       }

//       if (attempt === MAX_RETRIES) {
//         console.error(`❌ All attempts failed for categories, returning empty array`);
//         return [];
//       }

//       await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
//     }
//   }

//   return [];
// };

// const hasAnyContinueWatchingMovies = () => {
//   try {
//     const data = localStorage.getItem("vod_continue_watching");
//     if (!data) return false;
//     const list = JSON.parse(data);
//     return Array.isArray(list) && list.length > 0;
//   } catch {
//     return false;
//   }
// };
// export default function (filter: string) {
//   return async (pageIndex: number): Promise<any> => {
//     const username = playListUsername();
//     const password = playListPassword();
//     const apiIdentifier = api.getIdentifier ? api.getIdentifier() : "default";
//     const cacheKey = `${apiIdentifier}_${username}_vod_categories`;
//     const tileKey = `${filter}_${apiIdentifier}_${username}_vod_categories`;

//     let originalUrl = `/player_api.php?username=${username}&password=${password}&action=get_vod_categories`;
//     let finalUrl = originalUrl;
//     let hostHeader = null;

//     // Check cache first - but we'll modify the result dynamically
//     if (cache.has(cacheKey)) {
//       console.log(`💾 Using cached data for VOD categories`);
//       const cachedResult = await cache.get(cacheKey);

//       // Dynamically add Continue Watching if there are movies
//       return addContinueWatchingToCache(cachedResult, tileKey, filter);
//     }

//     // DNS transformation code...
//     try {
//       const baseUrl = api.baseURL || api.defaults?.baseURL || window.location.origin;
//       const fullUrl = `${baseUrl}${originalUrl}`;

//       console.log(`🌐 Starting DNS transformation for VOD categories: ${fullUrl}`);

//       const dnsResult = await dnsResolver.transformUrl(fullUrl);

//       if (typeof dnsResult === "object" && dnsResult.url) {
//         finalUrl = dnsResult.url.replace(baseUrl, "");
//         hostHeader = dnsResult.originalHost;
//       } else if (typeof dnsResult === "string") {
//         if (dnsResult !== fullUrl) {
//           finalUrl = dnsResult.replace(baseUrl, "");
//         }
//       }
//     } catch (dnsError) {
//       console.warn("❌ DNS transformation failed for VOD categories:", dnsError);
//       finalUrl = originalUrl;
//     }

//     console.log(`📞 Making VOD categories API call with URL: ${finalUrl}`);

//     const result = safeApiGetCategories(finalUrl, hostHeader ? { Host: hostHeader } : {})
//       .then(channels => {
//         console.log(`✅ VOD categories API call successful, processing ${channels?.length || 0} categories`);

//         let results = [];

//         if (Array.isArray(channels)) {
//           results = channels;
//         } else if (channels && typeof channels === "object") {
//           if (Array.isArray(channels.data)) {
//             results = channels.data;
//           } else if (Array.isArray(channels.categories)) {
//             results = channels.categories;
//           } else if (Array.isArray(channels.results)) {
//             results = channels.results;
//           } else {
//             results = [];
//           }
//         } else {
//           results = [];
//         }

//         console.log(`📊 Processed VOD categories: ${results.length} valid categories found`);

//         // Build special categories array conditionally
//         const specialCategories = [];

//         // Only add Continue Watching if there are movies to continue
//         if (hasAnyContinueWatchingMovies()) {
//           specialCategories.push({
//             category_id: "continue_watching",
//             category_name: "Continue Watching",
//             parent_id: 0,
//           });
//         }

//         // Always add Last Added
//         specialCategories.push({
//           category_id: "last_added",
//           category_name: "Last Added",
//           parent_id: 0,
//         });

//         const categoriesWithSpecial = [...specialCategories, ...results];

//         const existingTiles = leftoverTiles.get(tileKey) || [];
//         const tiles = existingTiles.concat(convertItemsToTilesChannelCategory(categoriesWithSpecial));

//         const chunks = chunkArray(tiles);
//         if (chunks[chunks.length - 1].length < 7) {
//           leftoverTiles.set(tileKey, chunks.pop() || []);
//         } else {
//           leftoverTiles.delete(tileKey);
//         }

//         console.log(`🎬 VOD categories processed: ${tiles.length} total tiles created`);
//         return tiles;
//       })
//       .catch(error => {
//         console.error(`❌ VOD categories API call failed:`, error);
//         cache.delete(cacheKey);
//         return [];
//       });

//     cache.set(cacheKey, result);
//     return result;
//   };
// }

// // Helper function to dynamically add Continue Watching to cached results
// function addContinueWatchingToCache(cachedTiles, tileKey, filter) {
//   // Check if Continue Watching should be present
//   const hasContinueWatching = hasAnyContinueWatchingMovies();

//   // Check if Continue Watching is already in the tiles
//   const hasContinueWatchingTile = cachedTiles.some(tile => tile.categoryID === "continue_watching");

//   // If should have it but doesn't, add it
//   if (hasContinueWatching && !hasContinueWatchingTile) {
//     console.log("✅ Adding Continue Watching to cached categories");

//     const continueWatchingTile = convertItemsToTilesChannelCategory([
//       {
//         category_id: "continue_watching",
//         category_name: "Continue Watching",
//         parent_id: 0,
//       },
//     ]);

//     // Insert at the beginning
//     return [...continueWatchingTile, ...cachedTiles];
//   }

//   // If shouldn't have it but does, remove it
//   if (!hasContinueWatching && hasContinueWatchingTile) {
//     console.log("🗑️ Removing Continue Watching from cached categories");
//     return cachedTiles.filter(tile => tile.categoryID !== "continue_watching");
//   }

//   // Otherwise return as is
//   return cachedTiles;
// }

import api from "..";
import { playListPassword, playListUsername } from "../../../state";
import { convertItemsToTilesChannelCategory, chunkArray } from "../formatters/ItemFormatter";
import { dnsResolver } from "./dnsResolver";

const cache = new Map<string, Promise<any>>();
const leftoverTiles = new Map<string, any[]>();

const safeApiGetCategories = async (url, headers = {}) => {
  const MAX_RETRIES = 2;
  const RETRY_DELAY = 1000;

  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      const response = await api._get(url, { headers });
      if (typeof response === "string" && response.trim().startsWith("<")) {
        throw new Error(`Received HTML instead of JSON for categories`);
      }
      return response;
    } catch (error) {
      if (attempt === MAX_RETRIES) {
        return [];
      }
      await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
    }
  }
  return [];
};

const hasAnyContinueWatchingMovies = () => {
  try {
    const data = localStorage.getItem("vod_continue_watching");
    if (!data) return false;
    const list = JSON.parse(data);
    return Array.isArray(list) && list.length > 0;
  } catch {
    return false;
  }
};

export default function (filter: string) {
  return async (pageIndex: number): Promise<any> => {
    const username = playListUsername();
    const password = playListPassword();
    const apiIdentifier = api.getIdentifier ? api.getIdentifier() : "default";
    const cacheKey = `${apiIdentifier}_${username}_vod_categories`;
    const tileKey = `${filter}_${apiIdentifier}_${username}_vod_categories`;

    let originalUrl = `/player_api.php?username=${username}&password=${password}&action=get_vod_categories`;
    let finalUrl = originalUrl;
    let hostHeader = null;

    if (cache.has(cacheKey)) {
      const cachedResult = await cache.get(cacheKey);
      return addSpecialCategoriesToCache(cachedResult, tileKey, filter);
    }

    try {
      const baseUrl = api.baseURL || api.defaults?.baseURL || window.location.origin;
      const fullUrl = `${baseUrl}${originalUrl}`;
      const dnsResult = await dnsResolver.transformUrl(fullUrl);

      if (typeof dnsResult === "object" && dnsResult.url) {
        finalUrl = dnsResult.url.replace(baseUrl, "");
        hostHeader = dnsResult.originalHost;
      } else if (typeof dnsResult === "string" && dnsResult !== fullUrl) {
        finalUrl = dnsResult.replace(baseUrl, "");
      }
    } catch (dnsError) {
      finalUrl = originalUrl;
    }

    const result = safeApiGetCategories(finalUrl, hostHeader ? { Host: hostHeader } : {})
      .then(channels => {
        let results = [];

        if (Array.isArray(channels)) {
          results = channels;
        } else if (channels && typeof channels === "object") {
          if (Array.isArray(channels.data)) {
            results = channels.data;
          } else if (Array.isArray(channels.categories)) {
            results = channels.categories;
          } else if (Array.isArray(channels.results)) {
            results = channels.results;
          }
        }

        const specialCategories = [];

        // Only add Continue Watching if has items
        if (hasAnyContinueWatchingMovies()) {
          specialCategories.push({
            category_id: "continue_watching",
            category_name: "Continue Watching",
            parent_id: 0,
          });
        }

        // ALWAYS add Favorites
        specialCategories.push({
          category_id: "favorites",
          category_name: "Favorites",
          parent_id: 0,
        });

        // ALWAYS add Last Added
        specialCategories.push({
          category_id: "last_added",
          category_name: "Last Added",
          parent_id: 0,
        });

        const categoriesWithSpecial = [...specialCategories, ...results];
        const existingTiles = leftoverTiles.get(tileKey) || [];
        const tiles = existingTiles.concat(convertItemsToTilesChannelCategory(categoriesWithSpecial));

        const chunks = chunkArray(tiles);
        if (chunks[chunks.length - 1].length < 7) {
          leftoverTiles.set(tileKey, chunks.pop() || []);
        } else {
          leftoverTiles.delete(tileKey);
        }

        return tiles;
      })
      .catch(error => {
        cache.delete(cacheKey);
        return [];
      });

    cache.set(cacheKey, result);
    return result;
  };
}

function addSpecialCategoriesToCache(cachedTiles, tileKey, filter) {
  const hasContinueWatching = hasAnyContinueWatchingMovies();
  const specialCategories = [];

  if (hasContinueWatching) {
    specialCategories.push({
      category_id: "continue_watching",
      category_name: "Continue Watching",
      parent_id: 0,
    });
  }

  // ALWAYS add Favorites
  specialCategories.push({
    category_id: "favorites",
    category_name: "Favorites",
    parent_id: 0,
  });

  specialCategories.push({
    category_id: "last_added",
    category_name: "Last Added",
    parent_id: 0,
  });

  const specialTiles = convertItemsToTilesChannelCategory(specialCategories);

  let updatedTiles = cachedTiles.filter(
    tile =>
      tile.categoryID !== "continue_watching" &&
      tile.categoryID !== "favorites" &&
      tile.categoryID !== "last_added",
  );

  return [...specialTiles, ...updatedTiles];
}